import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { StateService } from 'flux-core';
import { Injectable } from '@angular/core';
import { AbstractRouteResolver } from './framework/controller/abstract.resolver';

/**
 * This is a route resolver that can be used with simple static routes.
 *
 * @author  Ramishka
 * @since   2019-01-12
 */
@Injectable()
export class StaticRouteResolver extends AbstractRouteResolver implements CanActivate, CanDeactivate<any> {

    constructor ( protected state: StateService<any, any> ) {
        super( state );
    }

    /**
     * canActivate route guard which is invoked before the route is resolved.
     * Loading indicator is removed before the route is resolved.
     */
    public canActivate( route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot ): boolean {
        this.hideLoadingScreen();
        return true;
    }

    /**
     * canDeactivate route guard which is invoked before the route is resolved.
     * @returns boolean
     */
    public canDeactivate( component: any,
                          currentRoute: ActivatedRouteSnapshot,
                          currentState: RouterStateSnapshot,
                          nextState: RouterStateSnapshot ): boolean {
        // NOTE: Disable going back / forward for Embedded mode
        if ( this.state.get( 'ApplicationIsEmbedded' ) && this.state.get( 'PluginApp' ) !== 'msteams' ) {
            return false;
        }
        return true;
    }
}
